import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { ContactUsResponse } from './models/ContactUs-response.model';
import { ContactUsModel } from './models/ContactUs.model';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService extends BaseGQLService<ContactUsResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: ContactUsModel,
        clientName: 'ContactUsService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryContactUsContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }
}


